export const retryOnError = (asyncFn, delay = 7000) => {
  return asyncFn().catch(() => {
    return new Promise(resolve =>
      setTimeout(() => resolve(asyncFn()), delay)
    );
  });
};


